import $ from 'jquery';
import AhaDrawer, { type DrawerOptions } from './drawer';
import { getDrawerStacker } from 'javascripts/drawer_stacker_instance';
import type DrawerStacker from './drawer_stacker';

export default class AhaBottomDrawer extends AhaDrawer {
  constructor(stacker: DrawerStacker, options: DrawerOptions = {}) {
    options.drawerSelector ||= '.bottom-drawer';
    options.selector ||= '[data-bottom-drawer-url]';
    options.eventPrefix ||= 'aha-bottom-drawer';
    options.dataAttr ||= 'data-bottom-drawer-url';

    super(stacker, options);

    this.bindResizeHandle();
  }

  scrollable(url) {
    return false;
  }

  hide() {
    // Remove our custom height.
    $(this.drawerSelector).css('height', '');
    AhaDrawer.prototype.hide.call(this);
  }

  // we can't use class properties since the event listener is bound in the parent constructor
  doubleClickHandler(event) {
    // for now assume all bottom drawer URLs are not double clickable
  }

  bindResizeHandle() {
    const resizeHandle = $('.bottom-drawer__resize-handle');
    const $el = $(this.drawerSelector);

    resizeHandle.draggable({
      axis: 'y',
      drag: (event, ui) => {
        const newHeight =
          $el.height() + ($('.bottom-drawer').offset().top - event.clientY);
        $el.css('height', Math.round(newHeight));
        ui.position.top = 0;
      },
      start: (event, ui) => {
        $el.addClass('bottom-drawer--resizing');
      },
      stop: (event, ui) => {
        $el.removeClass('bottom-drawer--resizing');
      },
    });
  }

  static instance() {
    return getDrawerStacker()?.bottomDrawer;
  }
}
